import { viperApi } from '@/services/viper-api'

export const organizationService = {
  basePath: () => '/organizations',

  get(id) {
    return viperApi.get(this.basePath() + `/${id}`).then(({ data }) => data)
  }
}
